"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react")); // tslint:disable


var react_focus_lock_1 = __importDefault(require("react-focus-lock"));

var Transition_1 = __importDefault(require("react-transition-group/Transition")); // tslint:enable


var w3c_keys_1 = require("w3c-keys");

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Layout;

(function (Layout) {
  Layout["LAYER_LEFT"] = "lsg--drawer__layer lsg--drawer__left";
  Layout["LAYER_RIGHT"] = "lsg--drawer__layer lsg--drawer__right";
  Layout["LAYER_FULL"] = "lsg--drawer__layer lsg--drawer__full";
  Layout["SIDEMENU_LEFT"] = "lsg--drawer__side-menu lsg--drawer__left";
  Layout["SIDEMENU_RIGHT"] = "lsg--drawer__side-menu lsg--drawer__right";
  Layout["MEGAMENU"] = "lsg--drawer__mega-menu";
  Layout["MEGAMENU_LEGACY"] = "lsg--drawer__mega-menu-legacy";
})(Layout || (Layout = {}));

exports.Layout = Layout;

var Drawer =
/** @class */
function (_super) {
  __extends(Drawer, _super);

  function Drawer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onKeyDown = function (e) {
      switch (e.key) {
        case w3c_keys_1.Key.Escape:
          e.preventDefault();

          _this.props.onCloseClick();

          return;

        default:
          break;
      }
    };

    _this.handleBodyClick = function (e) {
      if (!_this.contentElm || utils_1.DomUtils.isTargetInsideContainer(e.target, _this.contentElm)) {
        return;
      }

      e.preventDefault();
      _this.props.onBackdropClick ? _this.props.onBackdropClick(e) : _this.props.onCloseClick();
    };

    _this.addDrawerOpenListeners = function () {
      document.body.addEventListener("keydown", _this.onKeyDown);
      document.body.addEventListener("click", _this.handleBodyClick);
    };

    _this.removeDrawerOpenListeners = function () {
      document.body.removeEventListener("keydown", _this.onKeyDown);
      document.body.removeEventListener("click", _this.handleBodyClick);
    };

    _this.addScrollLock = function () {
      var scrollBarWidth = window.innerWidth - document.body.offsetWidth;
      document.body.classList.add(CSSPrefix_1.lsgPre + "drawer-scrolllock");
      document.body.style.marginRight = scrollBarWidth + "px";
    };

    _this.removeScrollLock = function () {
      document.body.classList.remove(CSSPrefix_1.lsgPre + "drawer-scrolllock");
      document.body.style.marginRight = "";
    };

    return _this;
  }

  Drawer.prototype.componentDidMount = function () {
    if (this.props.open) {
      this.addDrawerOpenListeners();

      if (this.props.layout !== Layout.MEGAMENU && this.props.layout !== Layout.MEGAMENU_LEGACY) {
        this.addScrollLock();
      }
    }
  };

  Drawer.prototype.componentWillUnmount = function () {
    this.removeDrawerOpenListeners();
    this.removeScrollLock();
  };

  Drawer.prototype.componentDidUpdate = function (prevProps) {
    // close Drawer or change layout while the drawer is open
    if (prevProps.open && !this.props.open || this.props.open && this.props.layout !== prevProps.layout) {
      this.removeDrawerOpenListeners();
      this.removeScrollLock();
    } // open Drawer or change layout


    if (!prevProps.open && this.props.open || this.props.open && this.props.layout !== prevProps.layout) {
      this.addDrawerOpenListeners();

      if (this.props.layout !== Layout.MEGAMENU && this.props.layout !== Layout.MEGAMENU_LEGACY) {
        this.addScrollLock();
      }
    }
  };

  Drawer.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        htmlAttrs = _a.htmlAttrs,
        layout = _a.layout,
        id = _a.id,
        children = _a.children,
        className = _a.className,
        open = _a.open,
        noFocusLock = _a.noFocusLock,
        innerRef = _a.innerRef; // check aria attributes for dialog

    if ((!("role" in htmlAttrs) || htmlAttrs.role === "dialog") && !htmlAttrs["aria-labelledby"] && !htmlAttrs["aria-label"]) {
      // tslint:disable no-console
      console.warn("Accessibility: Missing label on Dialog(Layer) for react element " + this + ". Please add aria-labelledby or aria-label. Also consider using aria-descibedby if there is a meaningful description inside the Layer Component. If you are using the layer outside a dialog context, set the htmlAttrs.role to undefined or to the appropriate role."); // tslint:enable
    }

    return React.createElement(Transition_1["default"], {
      "in": open,
      unmountOnExit: true,
      mountOnEnter: true,
      timeout: {
        enter: 450,
        exit: 450
      },
      onEntered: function onEntered() {
        utils_1.EventUtils.dispatch(window, "openLsgDrawerEvent");
      }
    }, function (state) {
      return React.createElement(react_focus_lock_1["default"], {
        disabled: noFocusLock || !open,
        className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "drawer", CSSPrefix_1.prefixEnumClassNames(layout)])
      }, React.createElement("div", __assign({
        role: "dialog" // default role (can be overriden e.g. for menus)
        ,
        className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "drawer-inner", state !== "entering" && state !== "entered" && CSSPrefix_1.lsgPre + "drawer__hidden", className]),
        "aria-modal": open,
        ref: innerRef
      }, htmlAttrs), layout !== Layout.MEGAMENU_LEGACY && React.createElement("div", {
        className: CSSPrefix_1.lsgPre + "drawer-background"
      }), React.createElement("div", {
        className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "drawer-content"]),
        id: id,
        ref: function ref(r) {
          _this.contentElm = r;
        }
      }, React.createElement("div", {
        className: CSSPrefix_1.lsgPre + "drawer-content-inner"
      }, children))));
    });
  };

  Drawer.Layout = Layout;
  Drawer.defaultProps = {
    onCloseClick: function onCloseClick() {
      /* empty */
    },
    htmlAttrs: {},
    innerRef: function innerRef() {
      /* empty */
    }
  };

  Drawer.FixedArea = function (_a) {
    var children = _a.children;
    return React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "drawer-fixed"
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "drawer-fixed-inner"
    }, children));
  };

  return Drawer;
}(React.Component);

exports.Drawer = Drawer;
Drawer.FixedArea.displayName = "FixedArea";